module.exports = __webpack_public_path__ + "static/media/OPN_220.b88a9ea1.png";